import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getUnhandledInvoiceAmountSum = (
    token: string,
    backend: string,
) => {
    return fetch(
        `${getApiUrl(backend)}unhandled_invoice_amount_sum`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getUnhandledInvoiceAmountSum;
